import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "../components/Login.vue"
import Common from '../components/Common.vue'
import Product from '../components/Product/Product.vue'
import Materia from '../components/Materia.vue'
import WareHouse from '../components/WareHouse/WareHouse.vue'
import Storage from '../components/WareHouse/Storage.vue'
import ProductSeting from '../components/Product/ProductSeting.vue'
import WareHouseManage from '../components/WareHouse/WareHouseManage.vue'
import ProductManage from '../components/Product/ProductManage.vue'
import Warning from '../components/Warning.vue'

import VariableMainten from '../components/VariableManagement/VariableMainten.vue'
import WarningSeting from '../components/WaringManage/WarningSeting.vue'
import WarnSetList from '../components/WaringManage/WarnSetList.vue'
import WarningMonitor from '../components/WaringManage/WarningMonitor.vue'
import IntelligentWarehousingVisualization from '../components/IntelligentWarehousingVisualization.vue'
import ProductSetMater from '../components/Product/ProductSetMater.vue'
import StorageIn from '../components/StorageIn.vue'
import StorageOut from '../components/StorageOut.vue'
import Inventory from '../components/Inventory.vue'
import PlcSetting from '../components/PlcSetting.vue'
import CraftManage from '../components/Craft/CraftManage.vue'
import ProcessManage from '../components/Craft/ProcessManage.vue'
import VariableAttr from '../components/VariableManagement/VariableAttr.vue'
import RobotMonitor from '../components/MonitoringCenter/RobotMonitor.vue'
import Order from '../components/Order.vue'
import WorkpieceManage from '../components/WorkpieceManage.vue'
import AutoRobotMonitor from '../components/MonitoringCenter/AutoRobotMonitor.vue'
import Assemble from '../components/MonitoringCenter/Assemble.vue'
import AllMessage from '../components/MonitoringCenter/AllMessage.vue'
import ProductInspection from '../components/ProductionData/ProductInspection.vue'
import RobotStatistics from '../components/ProductionData/RobotStatistics.vue'
import RobotElectricity from '../components/ProductionData/RobotElectricity.vue'
import IntelligentStorage from '../components/ProductionData/IntelligentStorage.vue'
import IntellStorageElec from '../components/ProductionData/IntellStorageElec.vue'
import UserManage from '../components/User/UserManage.vue'
import RoleManage from '../components/Permissions/RoleManage.vue'
import UserRoleSet from '../components/User/UserRoleSet.vue'
import UserTypeManage from '../components/User/UserTypeManage.vue'
import MenuManage from '../components/Permissions/MenuManage.vue'
import Department from '../components/Organization/Department.vue'
import homePage from '../components/homePage.vue'
import logOne from '../components/logOne.vue'
import WarehouseManagement from '../components/WarehouseManagement.vue'
import WarehouseAreaOverview from '../components/WarehouseAreaOverview.vue'
import ChartComponent from '../components/ChartComponent.vue'
Vue.use(VueRouter)
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}


const routes = [
  {
    path: '/',
    redirect: '/common'
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/Wmsidm',
    name: 'Wmsidm',
    component: () => import('../components/WmsIdm.vue')
  },
  {
    path: '/common',
    component: Common,
    redirect: '/home',
    children: [
      {
        path: '/product',
        component: Product
      },
      {
        path:'/home',
        component:homePage
      }
      ,
      {
        path: '/materia',
        component: Materia
      },
      {
        path: '/warehouse',
        component: WareHouse
      },
      {
        path: '/storage',
        component: Storage
      },
      {
        path: '/productseting',
        component: ProductSeting
      },
      {
        path: '/warehousemanage',
        component: WareHouseManage
      },
      {
        path: '/productmanage',
        component: ProductManage
      },
      {
        path: '/warning',
        component: Warning
      },
      {
        path: '/variablemainten',
        component: VariableMainten
      },
      {
        path: '/warningseting',
        component: WarningSeting
      },
      {
        path: '/warnsetlist',
        component: WarnSetList
      },
      {
        path: '/productsetmater',
        component: ProductSetMater
      },
      {
        path: '/storagein',
        component: StorageIn
      },
      {
        path: '/storageout',
        component: StorageOut
      },
      {
        path: '/inventory',
        component: Inventory
      },
      {
        path: '/plcsetting',
        component: PlcSetting
      },
      {
        path: '/craftmanage',
        component: CraftManage
      },
      {
        path: '/processmanage',
        component: ProcessManage
      },
      {
        path: '/variableattr',
        component: VariableAttr
      },
      {
        path: '/order',
        component: Order
      },
      {
        path: '/workpiecemanage',
        component: WorkpieceManage
      },
      {
        path: '/productinspection',
        component: ProductInspection
      },
      {
        path: '/robotstatistics',
        component: RobotStatistics
      },
      {
        path: '/robotelectricity',
        component: RobotElectricity
      },
      {
        path: '/intelligentstorage',
        component: IntelligentStorage
      },
      {
        path: '/intellstorageelec',
        component: IntellStorageElec
      },
      {
        path: '/usermanage',
        component: UserManage
      },
      {
        path: '/rolemanage',
        component: RoleManage
      },
      {
        path: '/userroleset',
        component: UserRoleSet
      },
      {
        path: '/usertypemanage',
        component: UserTypeManage
      },
      {
        path: '/menumanage',
        component: MenuManage
      },
      {
        path: '/Department',
        component: Department
      },
    ],
  },
  {
    path: '/warningmonitor',
    component: WarningMonitor
  },
  {
    path:'/logOne',
    component:logOne
  },
  {
    path: '/robotmonitor',
    component: RobotMonitor
  },
  {
    path: '/autorobotmonitor',
    component: AutoRobotMonitor
  },
  {
    path: '/assemble',
    component: Assemble
  },
  {
    path: '/allmessage',
    component: AllMessage
  },
  {
    path:'/IntelligentWarehousingVisualization',
    component: IntelligentWarehousingVisualization
  },
  {
    path:'/WarehouseManagement',
    component: WarehouseManagement
  },
  {
    path:'/WarehouseAreaOverview',
    component: WarehouseAreaOverview
  }
  ,{
    path:'/ChartComponent',
    component:ChartComponent
  }
]

const router = new VueRouter({
  routes
})

//挂载路由导航守卫
// router.beforeEach((to, from, next) => {
//   //to:将要访问的路径   from:代表从哪个路径跳转而来  next:是一个函数，表示放行  next():放行  next('/login'):强制跳转
//   if (to.path === '/login') return next()
//   //获取token
//   const tokenStr = window.sessionStorage.getItem('token')
//   if (!tokenStr) return next('/login')
//   next()
// })

export default router
